import { render, staticRenderFns } from "./MdtTagsList.vue?vue&type=template&id=c01d7424&scoped=true"
import script from "./MdtTagsList.vue?vue&type=script&lang=js"
export * from "./MdtTagsList.vue?vue&type=script&lang=js"
import style0 from "./MdtTagsList.vue?vue&type=style&index=0&id=c01d7424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01d7424",
  null
  
)

export default component.exports